import { useState, useEffect, useCallback } from 'react';
import { Spin, Tag, Button, message, Input, Modal } from 'antd';
import { mobile } from '../../services/api';
import './mobile.css';

const LEVEL_COLOR = { '严重': 'red', '紧急': 'purple', '警告': 'orange', '提示': 'blue' };

export default function MobileAlarms() {
  const [loading, setLoading] = useState(true);
  const [alarms, setAlarms] = useState([]);
  const [noteOpen, setNoteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [note, setNote] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await mobile.alarms();
      setAlarms(res.data || []);
    } catch (err) {
      message.error(err.message || '加载失败');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAck = async () => {
    try {
      const res = await mobile.acknowledgeAlarm(selectedId, {
        create_work_order: true,
        handle_note: note || '现场已确认，生成工单处理',
      });
      message.success(res.message || '已确认并生成工单');
      setNoteOpen(false);
      setNote('');
      load();
    } catch (err) {
      message.error(err.message || '操作失败');
    }
  };

  if (loading) return <Spin style={{ display: 'block', margin: '60px auto' }} />;

  return (
    <div>
      <div className="mobile-card" style={{ marginBottom: 12, fontSize: 12, color: '#666' }}>
        现场确认告警后可一键生成工单，进入闭环处理流程
      </div>

      {alarms.length === 0 && (
        <div className="mobile-card" style={{ textAlign: 'center', color: '#999', padding: 32 }}>
          暂无待处理告警
        </div>
      )}

      {alarms.map((a) => (
        <div key={a.id} className="mobile-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Tag color={LEVEL_COLOR[a.level] || 'default'}>{a.level}</Tag>
            <Tag>{a.status}</Tag>
          </div>
          <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{a.title}</div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>{a.content}</div>
          <Button
            type="primary"
            block
            size="middle"
            onClick={() => { setSelectedId(a.id); setNoteOpen(true); }}
          >
            确认并生成工单
          </Button>
        </div>
      ))}

      <Modal
        title="确认告警"
        open={noteOpen}
        onCancel={() => setNoteOpen(false)}
        onOk={handleAck}
        okText="确认"
        cancelText="取消"
      >
        <div style={{ marginBottom: 8, fontSize: 13, color: '#666' }}>处理备注（可选）</div>
        <Input.TextArea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="现场情况说明" />
      </Modal>
    </div>
  );
}
